// import vendors.
import 'bootstrap';

// import execute.
require('./js/common')();
